/**
 * @module app.bdc.reports.bdcTPECtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function BDCTPECtrl($scope, $window, $rootScope, pricesService, marketService) {
        var self = {};

        self.orderForm = $rootScope.orderForm;

        if (!self.orderForm) {
            return $scope.goTo('/list');
        }

        self.order = $rootScope.order;
        pricesService.setOrderForm(self.orderForm);
        pricesService.setOrder(self.order);

        /**
         * Get the date of the day
         * @return {String}
         */
        self.getDate = function getDate() {
            if(self.order.isSigned){
                return moment(self.order.dateSignature).format('DD/MM/YYYY');
            }
            return moment().format('DD/MM/YYYY');
        };


        /**
         * Is NAP order ?
         * @return {Boolean}
         */
        self.isNAP = function isNAP() {
            return self.order.orderType.code === 'NAP';
        };

        self.isLadditionMarket = marketService.isLadditionMarket(self.order);

        self.TPEs = { offered: [], default: [] };
        self.TPEOptions = [];

        /**
         * Is the tpe purchasable ?
         * @param  {Array}  tpePrices
         * @return {Boolean}
         */
        self.isPurchasable = function isPurchasable(tpePrices) {
            for (var i = 0; i < tpePrices.length; i++) {
                if (tpePrices[i].type.code === 'ACHAT' && tpePrices[i].value > 0) {
                    return true;
                }
            }
            return false;
        };

        /**
         * init TPE list
         */
        function _initTPEList() {
            var bluetoothOptionAdded = false;
            for (var i = 0; i < self.order.options.length; i++) {
                if (
                    self.order.options[i].optionType.code === 'TPE' ||
                    self.order.options[i].optionType.code === 'LOGICIEL'
                ) {
                    if (self.order.options[i].isTPEDevice) {
                        if (self.order.options[i].nbOptions > 0) {
                            self.TPEs.default.push(self.order.options[i]);
                            if (!self.order.options[i].isDefault) {
                                self.TPEOptions.push(self.order.options[i]);
                                bluetoothOptionAdded = true;
                            }
                        }
                        if (self.order.options[i].nbOffered > 0) {
                            self.TPEs.offered.push(self.order.options[i]);
                            if (!self.order.options[i].isDefault && !bluetoothOptionAdded) {
                                self.TPEOptions.push(self.order.options[i]);
                            }
                        }
                    }
                    else {
                        self.TPEOptions.push(self.order.options[i]);
                    }
                }

                if (self.order.options[i].optionType.code === 'LADDITION_TPE') {
                    if (self.order.options[i].isTPEDevice) {
                        if (self.order.options[i].nbOptions > 0) {
                            self.TPEs.default.push(self.order.options[i]);
                        }
                    }
                }
            }
        }

        self.filterPriceLoc48AndMarketType = function filterPriceLoc48AndMarketType(price) {
            if (price.type.code === 'LOC48' && price.marketType.code === self.order.marketType.code) {
                return true;
            }
        };

        self.filterPriceAchatAndMarketType = function filterPriceAchatAndMarketType(price) {
            if (price.type.code === 'ACHAT' && price.marketType.code === self.order.marketType.code) {
                return true;
            }
        };

        _initTPEList();

        return self;
    }

    BDCTPECtrl.$inject = ['$scope', '$window', '$rootScope', 'pricesService', 'marketService'];

    angular.module('app.bdc.reports.bdcTPECtrl', []).controller('BDCTPECtrl', BDCTPECtrl);
});
